import React from "react";
import { cls } from "@wss/cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import Stars from "~/common/Stars";
import { CarouselItem } from "~/common/Store/models/CarouselItem";
import { ProductCategory } from "~/common/Store/models/ProductPage";
import SaleBadgeAndPricing from "~/common/SaleBadgeAndPricing";
interface Props {
  seeMoreProductsCarouselItems: CarouselItem[];
  category: ProductCategory;
  isEverliving: boolean;
}
const SeeMoreProductsCarousel = ({
  seeMoreProductsCarouselItems,
  category,
  isEverliving
}: Props) => {
  const hasActiveSale = seeMoreProductsCarouselItems.slice(0, 5).some(item => item.displaySalePrice);
  const title = isEverliving ? "This Product is no longer available" : "See more products like this!";
  const plusRibbon = <div className="ribbon-stack absolute lz:static lz:inline-block left-0 overflow-hidden">
      <a href="/plus/" className="ribbon ribbon--mini ribbon--plus mx-2 pl-3 lz:pl-1 -ml-2 lz:ml-2 bg-blue-500">
        <span className="ribbon__text">plus</span>
      </a>
    </div>;
  return <div className="carousel-wrap suggested-products ppc-similar-products seasonal-wrap" data-testid="seeMoreProductsCarousel" data-sentry-component="SeeMoreProductsCarousel" data-sentry-source-file="SeeMoreProductsCarousel.tsx">
      <div className="seasonal-attached flex xs:flex-col items-center justify-between xs:flex-start xs:justify-center text-left xs:p-4 md:p-6 lg:p-8 border-l-0 border-b xs:border-l">
        <div>
          <h2 className="text-lg leading-none xs:text-2xl xs:leading-6">
            {title}
          </h2>
          Browse our full selection
        </div>
        <div className="flex items-end xs:flex-start xs:w-full">
          <a className="btn btn-primary similar-see-more el-button m-0 xs:mt-4" href={category.link}>
            See more products
          </a>
        </div>
      </div>
      <div className="basic-carousel carousel-box">
        <div id="homePageCarouselFeatured" className="ag-carousel-frame box">
          <ul className="ag-carousel ag-full scrollbar-width-none flex mb-0 ml-0 overflow-x-auto relative snap-x scroll-smooth">
            {seeMoreProductsCarouselItems.slice(0, 5).map(item => <li className="ag-item el-product relative mr-0 block px-3 snap-start" style={{
            borderRight: "1px solid #e6e6e6"
          }} key={item.itemNumber} gtm-tracking-number={item.itemNumber}>
                <div className="product-image">
                  <a href={item.link} className="image similar-link" title={item.description}>
                    <img alt={item.description} src={item.imagePath} />
                  </a>
                </div>
                <div className="details">
                  <div className={cls("flex", "justify-center", "items-center")}>
                    {item.isWebstaurantPlusEligible && plusRibbon}
                    <div className={cls("rating", "h-[17px]")}>
                      <Stars rating={item.starRating} />
                    </div>
                  </div>
                  <a href={item.link} className="description similar-link mt-1">
                    {item.description}
                  </a>
                </div>
                <div className={cls("pricing", "mb-1", "mt-4", "pt-0", "flex", "flex-col", hasActiveSale && cls("h-[38px]", "justify-end"))}>
                  {item.displaySalePrice ? <SaleBadgeAndPricing price={item.price} dataTestId="see-more-products-carousel-sale" salePricingClassNames={cls("mb-1 text-center")} saleBadgeExtraClassNames={cls("mr-1", "p-0.5")} /> : null}
                  <p className="price">
                    {item.displaySalePrice ? formatAsCurrency.formatIfUndefined(item.salePrice) : formatAsCurrency.formatIfUndefined(item.price)}
                    {item.unitOfMeasure && <span className="each" style={{
                  fontSize: 11
                }}>
                        /{item.unitOfMeasure}
                      </span>}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
};
export default SeeMoreProductsCarousel;